<h1 class="mb-2">
  <mdb-icon fas icon="tasks"></mdb-icon> Vendedor rubro
</h1>

<!-- Heading -->
<div class="card card-miga-pan mb-2 wow">
  <!--Card content-->
  <div class="card-body d-sm-flex p-1 justify-content-between">
    <p class="mb-0">
      <span class="grey-text">Maestros</span>
      <span> /</span>
      <span>Vendedor rubro</span>
    </p>
  </div>
</div>
<!-- Heading -->

<!-- Cabecera de botones -->
<form autocomplete="off" [formGroup]="formHeader">
  <div class="card mb-2 wow detalle-cliente">
    <div class="card-body justify-content-between">
      <div class="row filtros-body">
        <div class="col" style="max-width: 300px">
          <div class="md-form mb-0">
            <input value="" type="text" id="rutVendedor" class="form-control" placeholder="9.999.999-9" required
              #rutVendedor formControlName="rutVendedor" formatRut />
            <label for="rutVendedor">Rut del Vendedor</label>
            <!-- <div *ngIf="
                  formHeader.get('rutVendedor').invalid &&
                  (formHeader.get('rutVendedor').dirty ||
                  formHeader.get('rutVendedor').touched)
              ">
              <mdb-error *ngIf="formHeader.get('rutVendedor').hasError('required')">
                Ingrese rut vendedor
              </mdb-error>
            </div> -->
          </div>
        </div>
        <div class="col d-flex">
          <button mdbBtn type="button" class="btn-cuadrado" color="secondary" mdbWavesEffect
            (click)="abrirModalSeleccionarVendedor()">
            <mdb-icon fas icon="search"></mdb-icon>
          </button>
          <h6 class="text-info" style="display: contents;">
            {{ vendedorSeleccionado?.nombre }}
          </h6>
        </div>
      </div>
    </div>
  </div>
</form>

<div class="card mb-2 wow">
  <!--Card content-->
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h5 *ngIf="!vendedorSeleccionado">Rubros</h5>
        <h5 *ngIf="vendedorSeleccionado">Rubros de {{vendedorSeleccionado.nombre}}</h5>

        <div *ngFor="let rubro of rubrosVendedor" class="chip"
          [ngClass]="{'green lighten-2 white-text': rubro.asignado}" (click)="toogleAssigned(rubro)">
          {{rubro.rubro_nombre}}
          <!-- <mdb-icon fas icon="times" class="close" (click)="toogleAssigned(rubro)"></mdb-icon> -->
        </div>
      </div>
    </div>
  </div>
</div>

<div class="card mb-2 wow">
  <div class="card-body d-sm-flex p-1 justify-content-end">
    <button mdbBtn type="button" color="success" mdbWavesEffect (click)="guardar()">
      Guardar
    </button>
  </div>
</div>

<!-- MODAL seleccionarVendedor -->
<app-modal-seleccionar-vendedor [multiple]="false" queryType="ONLY_RUT"
  (onSelectSingle)="onVendedorSeleccionado($event)" (onNotFound)="onVendedorNoEncontrado()">
</app-modal-seleccionar-vendedor>